import { register } from 'swiper/element/bundle';
import { Logger } from '../app/utils/logger';

/**
 * @description Swiper.
 * @exports
 * @class Swiper
 */
export class Swiper {
  /**
   * Creates an instance of Swiper.
   *
   * @param {Logger} logger Logger.
   * @memberof Swiper
   */
  constructor(private readonly logger: Logger) {}

  /**
   * @description Init.
   * @memberof Swiper
   */
  init(): void {
    const log = this.logger.child('Swiper');

    try {
      log.debug('init');

      register();

      log.debug('ready');
    } catch (error: any) {
      log.debug('not ready');
      log.error(`throw an error, message="${error.message}"`, error);
    }
  }
}
